<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>현금 주문 관리</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search_keyword"
          label="유저 아이디 검색"
          hide-details
          dense
          solo
          flat
          background-color="rgba(255,255,255,0.15)"
          dark
          style="max-width:200px;"
          @keyup.enter="OnClick_SearchUser"
          class="mr-2"
        ></v-text-field>
        <v-btn color="white" outlined dark small @click="OnClick_SearchUser">검색</v-btn>
        <v-btn icon class="ml-2" @click="Load_OrderList"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>

      <div style="overflow-x: auto;">
        <v-data-table
          :footer-props="{'items-per-page-options': [20, 50, -1]}"
          :headers="headers"
          :items="order_list"
          :loading="loadingData"
        >
          <template v-slot:item="row">
            <tr>
              <td><span :style="{ fontWeight: '900' }">{{ row.item.PID }}</span></td>
              <td><span :style="{ fontWeight: '900' }">{{ row.item.USER_ID }}</span></td>
              <td>{{ row.item.PRODUCT_NAME || row.item.PRD_NM || '-' }}</td>
              <td>{{ formatCoin(row.item.AMOUNT || row.item.PRICE || 0) }} 원</td>
              <td>
                <span :style="{ fontWeight: '900', color: row.item.PROCESS_STATE === 'WAIT' ? 'blue' : 'grey' }">
                  {{ row.item.PROCESS_STATE }}
                </span>
              </td>
              <td>{{ row.item.CREATE_DT }}</td>
              <td>
                <v-btn width="80px" color="indigo" class="white--text" small @click="OnClick_ShowDetail(row.item)">상세</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- 상세 다이얼로그 -->
    <v-dialog v-model="dialog_popup" max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="text-h5 mb-3">
          주문 상세 [{{ dialog_selected_item.USER_ID }}]
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="5" class="dialog_title_text">주문번호</v-col>
            <v-col class="dialog_info_text">{{ dialog_selected_item.PID }}</v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="5" class="dialog_title_text">유저 아이디</v-col>
            <v-col class="dialog_info_text">{{ dialog_selected_item.USER_ID }}</v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="5" class="dialog_title_text">상품명</v-col>
            <v-col class="dialog_info_text">{{ dialog_selected_item.PRODUCT_NAME || dialog_selected_item.PRD_NM || '-' }}</v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="5" class="dialog_title_text">금액</v-col>
            <v-col class="dialog_info_text">{{ formatCoin(dialog_selected_item.AMOUNT || dialog_selected_item.PRICE || 0) }} 원</v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="5" class="dialog_title_text">주문일시</v-col>
            <v-col class="dialog_info_text">{{ dialog_selected_item.CREATE_DT }}</v-col>
          </v-row>
          <v-divider/>
          <v-row class="align-center">
            <v-col cols="5" class="dialog_title_text">처리상태</v-col>
            <v-col v-if="dialog_selected_item.PROCESS_STATE === 'WAIT' || !dialog_selected_item.PROCESS_STATE">
              <v-select
                v-model="dropdown_selected"
                :items="dropdown_items"
                label="선택하세요"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col v-else class="dialog_info_text">{{ dialog_selected_item.PROCESS_STATE }}</v-col>
          </v-row>
          <v-divider/>
          <v-row v-if="dropdown_selected === 'CANCEL' && dialog_selected_item.PROCESS_STATE === 'WAIT'">
            <v-col cols="12">
              <v-text-field
                label="취소 사유 (취소 처리 시 필수)"
                v-model="dialog_cancel_comment"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_popup = false">닫기</v-btn>
          <v-btn
            v-if="dialog_selected_item.PROCESS_STATE === 'WAIT' || !dialog_selected_item.PROCESS_STATE"
            color="blue darken-1"
            text
            @click="OnClick_EditOrderState"
            :loading="loadingData"
          >확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="py-12"/>
  </div>
</template>

<script>
import { mandoora_cash_order } from '../../api/mandoora';

export default {
  name: 'MandooraGameCashOrderList',
  data: () => ({
    loadingData: false,
    search_keyword: '',
    order_list: [],
    dialog_popup: false,
    dialog_selected_item: {},
    dialog_cancel_comment: '',
    dropdown_selected: null,
    dropdown_items: ['DONE', 'CANCEL'],
    headers: [
      { text: '주문번호', value: 'PID' },
      { text: '유저 아이디', value: 'USER_ID' },
      { text: '상품명', value: 'PRODUCT_NAME' },
      { text: '금액', value: 'AMOUNT' },
      { text: '상태', value: 'PROCESS_STATE' },
      { text: '등록일', value: 'CREATE_DT' },
      { text: '관리', value: 'manage', sortable: false },
    ],
  }),
  created() {
    this.Load_OrderList();
  },
  methods: {
    async Load_OrderList() {
      this.loadingData = true;
      try {
        const body = await mandoora_cash_order.get_cash_order_list({ count: 200 });
        this.order_list = body?.order_list || body?.list || [];
      } catch (e) {
        console.error('[Mandoora CashOrder] get_cash_order_list', e);
      } finally {
        this.loadingData = false;
      }
    },
    async OnClick_SearchUser() {
      if (!this.search_keyword.trim()) { this.Load_OrderList(); return; }
      this.loadingData = true;
      try {
        const body = await mandoora_cash_order.search_cash_order_list({ user_id: this.search_keyword });
        this.order_list = body?.order_list || body?.list || [];
      } catch (e) {
        console.error('[Mandoora CashOrder] search', e);
      } finally {
        this.loadingData = false;
      }
    },
    OnClick_ShowDetail(item) {
      this.dialog_selected_item = item;
      this.dialog_cancel_comment = '';
      this.dropdown_selected = null;
      this.dialog_popup = true;
    },
    async OnClick_EditOrderState() {
      const process_state = this.dropdown_selected;
      if (!process_state) { alert('처리 상태를 선택해주세요.'); return; }
      if (process_state === 'CANCEL' && !this.dialog_cancel_comment) {
        alert('취소처리에는 사유 작성이 필요합니다.');
        return;
      }
      this.loadingData = true;
      try {
        await mandoora_cash_order.edit_cash_order_state({
          pid: this.dialog_selected_item.PID,
          process_state,
          comment: this.dialog_cancel_comment,
        });
        alert('처리 완료');
        this.dialog_popup = false;
        await this.Load_OrderList();
      } catch (e) {
        console.error('[Mandoora CashOrder] edit_cash_order_state', e);
        alert('처리 실패');
      } finally {
        this.loadingData = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
.dialog_title_text { font-weight: bold; font-size: 15px; margin-bottom: 6px; margin-top: 6px; }
.dialog_info_text { font-weight: bold; font-size: 15px; margin-top: 7px; }
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
}
</style>
